/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { getLogger } from "logging";
import { convertStringToJson } from '../convertStringToJson';

/**
 * @param {string} method
 * @param {string} url
 * @param {object|string} headers
 * @param {string=} body
 * @param {boolean=} withCors
 * @return {Promise<Response>|Promise}
 */
export const httpRequest = (method, url, headers, body, withCors) => {
    const parsedHeaders = new Headers();
    const logger = getLogger(`HTTP Delete ${method}:`);
    let jsonInputHeader = null;
    try {
        jsonInputHeader = convertStringToJson(headers, 'Headers');
    } catch (error) {
        logger.error(error);
    }
    if (jsonInputHeader !== null) {
        for (const [key, value] of Object.entries(jsonInputHeader)) {
            parsedHeaders.append(key, value);
        }
    }

    const init = {
        method: method,
        headers: parsedHeaders,
        mode: 'cors',
        cache: 'default'
    };

    if (body) {
        init.body = body;
    }

    if (withCors) {
        init.credentials = 'include';
    }

    return fetch(url, init);
}